// libraries
import qs from 'qs';
// services
import AxiosInstanceCreator from 'services/api';

// models
import {
  ReqDeleteTbmStatusList,
  ReqMapTbmStatusList,
  ReqMapTbmStatusListByIds,
  ReqTbmAttendances,
  ReqTbmStatusList,
  ResMapTbmStatusList,
  ResTbmAttendances,
  ResTbmStatusList
} from '../models/tbm.model';
import { BaseApiResponse } from 'modules';
import { ReqTbmAttendanceHistory, ResTbmAttendanceHistory } from '../models/attendance.model';

const tbmInstance = new AxiosInstanceCreator().create();

export const tbmApi = {
  /**
   * TBM 상태 목록 조회
   * @param {workDate, status, taskLevel, keyword, page, size} data
   * @returns
   */
  async getTbmStatusList(data: ReqTbmStatusList): Promise<ResTbmStatusList> {
    return tbmInstance.get(`/tbm?${qs.stringify(data)}`).then((res) => res.data);
  },

  /**
   * TBM 상태 목록 조회 맵 대시보드 용
   */
  async getMapTbmStatusList(data: ReqMapTbmStatusList): Promise<ResMapTbmStatusList> {
    return tbmInstance.get(`/tbm/list/search`, { params: data }).then((res) => res.data);
  },

  /**
   * TBM 상태 목록 조회 (By TBM Ids) 맵 대시보드 용
   */
  async getMapTbmStatusListByIds(data: ReqMapTbmStatusListByIds): Promise<ResMapTbmStatusList> {
    return tbmInstance.get(`/tbm/list/ids?tbmIds=${data.tbmIds}`).then((res) => res.data);
  },

  /**
   * TBM 상세 조회
   * @param {tbmId} tbmId
   * @returns
   */
  async getTbmDetail(tbmId: string) {
    return tbmInstance.get(`/tbm/${tbmId}`).then((res) => res.data);
  },

  /**
   * TBM 파일 조회
   * @param {fileId} fileId
   * @returns
   */
  async getTbmFile(fileId: string) {
    return tbmInstance
      .get(`/tbm/downloads/${fileId}`, { responseType: 'blob' })
      .then(async (res) => {
        let imageURL = await URL.createObjectURL(res.data);

        return imageURL;
      });
  },

  /**
   * TBM 참여자 조회
   * @param {tbmId, keyword, page, size} data
   * @returns
   */
  async getTbmAttendance(data: ReqTbmAttendances): Promise<ResTbmAttendances> {
    return tbmInstance.get(`/tbm/attendance?${qs.stringify(data)}`).then((res) => res.data);
  },

  async fetchTbmAttendanceHistory(data: ReqTbmAttendanceHistory): Promise<ResTbmAttendanceHistory> {
    return tbmInstance.get(`/tbm/attendance/history?${qs.stringify(data)}`).then((res) => res.data);
  },

  async deleteTbmStatusList(data: ReqDeleteTbmStatusList): Promise<BaseApiResponse> {
    return tbmInstance.delete(`/tbm`, { data: data }).then((res) => res.data);
  }
};
